<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>

import { computed } from '@vue/composition-api';
import useRoom from '@/compositions/useRoom';
import useUser from '@/compositions/useUser';
import useSocket from '@/compositions/useSocket';
import i18n from '@/i18n';
import Locale from '@/locale';

export default {
  name: 'App',
  components: {},
  metaInfo() {
    const vacancy = this.roomVacancy;
    const company = this.roomCompany;
    let title;
    if (vacancy && company) {
      title = `${vacancy} — ${company}`;
    } else if (vacancy) {
      title = vacancy;
    } else {
      title = this.$t('pageTitle');
    }
    return {
      title,
      titleTemplate: '%s | Huntica',
    };
  },
  setup(_, context) {
    const {
      setRoom,
      login,
      setCandidateAuth,
      setAuth,
      generateRoom,
      findOrCreateRoom,
      existingRoom,
    } = useRoom(context);

    const { initSocket } = useSocket();

    async function processRoom() {
      const room = context.root.$route.query.room;
      const secret = context.root.$route.query.secret;
      const candidateSecret = context.root.$route.query.candidate;

      if (!room) {
        generateRoom();
      }
      setRoom(room);
      setAuth({ secret });
      setCandidateAuth({ secret: candidateSecret });
      await login();
      await findOrCreateRoom();
      Locale.change(existingRoom.value?.interview?.locale || 'ru');
    }

    const { initUser } = useUser();
    initUser();
    initSocket();

    processRoom();

    return {
      roomVacancy: computed(() => existingRoom.value?.vacancy?.title || null),
      roomCompany: computed(() => existingRoom.value?.company?.title || null),
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
pageTitle: Video Interview
</i18n>

<i18n locale="ru" lang="yaml">
pageTitle: Видеособеседование
</i18n>

<style>
@import "~bootstrap/dist/css/bootstrap.min.css";
#app {
  font-family: 'MuseoSansCyrl', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  touch-action: pan-x pan-y;
}
</style>
